import React from "react";
import { Row, Col } from "antd";
import './style/index';
class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'cs-top',
    title: ''
  }
  constructor(props) {
    super(props);
  }
  render () {
    const { prefixCls, title, buttons } = this.props;
    return (
      <div>
        <Row className={prefixCls}>
          <Col span={14} className={`${prefixCls}-title`}>{title}</Col>
          <Col span={10} className={`${prefixCls}-button`}>{buttons}</Col>
        </Row>
        <div className={`${prefixCls}-topCon`}>
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/public/cs-top/index.js